import { ca } from '@cian/analytics';

export function trackCalculatorBlockShow() {
  ca('eventSite', {
    action: 'show',
    label: 'Calculator',
    category: 'Mortgage',
    name: 'oldevent',
  });
}

export function trackAnyClickOnCalculator() {
  ca('eventSite', {
    action: 'click',
    label: 'Calculator',
    category: 'Mortgage',
    name: 'oldevent',
  });
}

export function trackSendFormFromCalculator() {
  ca('eventSite', {
    action: 'register',
    label: 'Calculator',
    category: 'Mortgage',
    name: 'oldevent',
  });
}
